export default __webpack_public_path__ + "static/media/PPI-garden-bed-012.f8f82a87.jpg";